import Request from '@/requests/Request'

const resource = "/usuario"

export default {
    
    findAll() {
        return Request.get(`${resource}/listarUsuarios`);
    },    
    
    post(usuario) {
        return Request.post(`${resource}`, usuario);
    },

    getUsuario() {
        return Request.get(`${resource}/authenticated`);
    },

    getUsuarioById(id) {
        return Request.get(`${resource}/${id}`);
    },

    getByAutenticacao() {
        return Request.get(`${resource}/usuario`);
    },

    getAll() {
        return Request.get(`${resource}/listarUsuarios`);
    },

    getMsgEmail(email) {
        return Request.get("public/usuario/recuperacao?email=" + email);
    },


    postSenha(token) {
        return Request.post("public/usuario/nova-senha", token)
    },

    postRedefinirSenha(usuario) {
        return Request.post("/usuario/redefinir-senha", { id: usuario.id, })
    },

    put(usuario) {
        return Request.put(`${resource}`,
            {
                id: usuario.id,
                nome: usuario.nome,
                email: usuario.email,
                ativo: usuario.ativo,
                estado: usuario.estado,
                papelTemporario: usuario.papelTemporario,
                organizacao: {
                    id: usuario.organizacao.id,
                },                
            });
    },

    putSenha(usuario) {
        return Request.put(`${resource}/alterarSenha`,
            {
                senhaAtual: usuario.senhaAtual,
                novaSenha: usuario.novaSenha
            });
    },

    delete(usuario) {
        return Request.delete(`${resource}/${usuario}`);
    },

}
